import AnalyticsContext from '@root/core/src/contexts/analytics/analytics-context';
import AnalyticsService from '@root/core/src/services/analytics-service';
import { useCallback, useContext, useEffect, useRef } from '@root/vendor/react';

export default function useAnalytics(analyticsContext, shouldTrackViewEvent = true) {
  const { eventPrefix } = useContext(AnalyticsContext);

  // Store properties in a ref
  const propertiesRef = useRef({});

  const addProperty = useCallback((key, value) => {
    propertiesRef.current[key] = value;
  }, []);

  useEffect(() => {
    if (shouldTrackViewEvent) {
      const eventProperties = {
        eventPrefix,
        ...propertiesRef.current,
      };
      AnalyticsService.trackViewEvent(analyticsContext, eventProperties);
    }
  }, [analyticsContext, eventPrefix, shouldTrackViewEvent]);

  const trackClick = useCallback((event, properties) => {
    const eventProperties = {
      eventPrefix,
      ...propertiesRef.current,
      ...properties,
    };
    AnalyticsService.trackClickEvent(analyticsContext, event, eventProperties);
  }, [analyticsContext, eventPrefix]);

  const trackEvent = useCallback((event, properties) => {
    const eventProperties = {
      eventPrefix,
      ...propertiesRef.current,
      ...properties,
    };
    AnalyticsService.trackEvent(analyticsContext, event, eventProperties);
  }, [analyticsContext, eventPrefix]);

  const getDistinctId = useCallback(() => {
    return AnalyticsService.getDistinctId();
  }, []);

  return {
    addProperty,
    getDistinctId,
    trackClick,
    trackEvent,
  };
}
